define("shared/components/shared/enterprise-modal", ["exports", "@ember/component", "@ember/template-factory", "ember-concurrency/-private/async-arrow-runtime", "@ember/service", "@glimmer/component", "@glimmer/tracking", "ember-changeset", "ember-changeset-validations", "ember-changeset-validations/validators", "ember-concurrency", "later/utils/fetch", "later/utils/is-free-email", "shared/utils/retry"], function (_exports, _component, _templateFactory, _asyncArrowRuntime, _service, _component2, _tracking, _emberChangeset, _emberChangesetValidations, _validators, _emberConcurrency, _fetch, _isFreeEmail, _retry) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;

  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/-private/async-arrow-runtime",0,"ember-cli-htmlbars",0,"@ember/service",0,"@glimmer/component",0,"@glimmer/tracking",0,"ember-changeset",0,"ember-changeset-validations",0,"ember-changeset-validations/validators",0,"ember-concurrency",0,"later/utils/fetch",0,"later/utils/is-free-email",0,"shared/utils/retry"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <Shared::Modal @closable={{not this.handleSubmit.isRunning}} @close={{@closeModal}} @focusTrap={{true}} as |modal|>
    <modal.card @portrait={{true}}>
      {{#if this.hasSuccessfullySubmitted}}
        <modal.card-header>
          <h2 class="o--modalHeader__title">{{t "plans.enterprise.modal.submitted.title"}}</h2>
          <p class="u--text--light u--m__b__0">{{t "plans.enterprise.modal.submitted.description"}}</p>
        </modal.card-header>
        <modal.card-body class="u--p__t__0">
          <p><strong>{{t "plans.enterprise.modal.submitted.name"}}</strong> {{this.formChangeset.name}}</p>
          <p><strong>{{t "plans.enterprise.modal.submitted.email"}}</strong> {{this.formChangeset.email}}</p>
        </modal.card-body>
        <modal.card-footer>
          <Shared::Ui::Button
            @onClick={{@closeModal}}
            @text={{t "shared_words.close"}}
            @variant="outline"
            class="u--float--right qa—requestDemo__close"
          />
        </modal.card-footer>
      {{else}}
        {{! Header }}
        <modal.card-header>
          <h2 class="o--modalHeader__title">{{t "shared_phrases.request_pricing"}}</h2>
          <p class="u--text--light u--m__b__0">{{t "plans.enterprise.modal.description"}}</p>
        </modal.card-header>
        {{! Body }}
        <modal.card-body class="u--p__t__0">
          <form>
            {{! Full Name }}
            <div class="o--formWrapper u--hide--mf">
              <label for="exampleInput">{{t "plans.enterprise.modal.name"}}</label>
              <Input
                @type="text"
                @value={{this.formChangeset.name}}
                class={{concat-classes
                  "o--form__input qa—requestDemo__ownerName"
                  (if this.formChangeset.error.name "tMK--asideForm__inputError")
                }}
                disabled={{this.handleSubmit.isRunning}}
                id="exampleInput"
                placeholder={{t "plans.enterprise.modal.name_placeholder"}}
              />
              {{#if this.formChangeset.error.name}}
                <span class="o--form__helpText u--text--danger qa--requestDemo__nameError">
                  {{t "plans.enterprise.modal.name_error"}}
                </span>
              {{/if}}
            </div>
            {{! Email }}
            <div class="o--formWrapper u--hide--mf">
              <label for="exampleInput">{{t "plans.enterprise.modal.email"}}</label>
              <Input
                @type="email"
                @value={{this.formChangeset.email}}
                class={{concat-classes
                  "o--form__input qa—requestDemo__ownerEmail"
                  (if this.formChangeset.error.email "tMK--asideForm__inputError")
                }}
                disabled={{this.handleSubmit.isRunning}}
                id="exampleInput"
                placeholder={{t "plans.enterprise.modal.email_placeholder"}}
              />
              {{#if this.formChangeset.error.email}}
                <span class="o--form__helpText u--text--danger qa--requestDemo__emailError">
                  {{this.emailErrorMessage}}
                </span>
              {{/if}}
            </div>
          </form>
        </modal.card-body>
        {{! Footer }}
        <modal.card-footer>
          <Shared::Ui::Button
            @onClick={{@closeModal}}
            @text={{t "shared_words.close"}}
            @variant="outline"
            class="qa—requestDemo__close"
          />
          <Shared::Ui::Button
            @onClick={{perform this.handleSubmit}}
            @text={{t "shared_phrases.request_pricing"}}
            @variant="primary"
            class="u--float--right qa—requestDemo__requestBtn"
            disabled={{this.isSubmitDisabled}}
          />
        </modal.card-footer>
      {{/if}}
    </modal.card>
  </Shared::Modal>
  */
  {
    "id": "aFDcC7vZ",
    "block": "[[[8,[39,0],null,[[\"@closable\",\"@close\",\"@focusTrap\"],[[28,[37,1],[[30,0,[\"handleSubmit\",\"isRunning\"]]],null],[30,1],true]],[[\"default\"],[[[[1,\"\\n  \"],[8,[30,2,[\"card\"]],null,[[\"@portrait\"],[true]],[[\"default\"],[[[[1,\"\\n\"],[41,[30,0,[\"hasSuccessfullySubmitted\"]],[[[1,\"      \"],[8,[30,2,[\"card-header\"]],null,null,[[\"default\"],[[[[1,\"\\n        \"],[10,\"h2\"],[14,0,\"o--modalHeader__title\"],[12],[1,[28,[35,3],[\"plans.enterprise.modal.submitted.title\"],null]],[13],[1,\"\\n        \"],[10,2],[14,0,\"u--text--light u--m__b__0\"],[12],[1,[28,[35,3],[\"plans.enterprise.modal.submitted.description\"],null]],[13],[1,\"\\n      \"]],[]]]]],[1,\"\\n      \"],[8,[30,2,[\"card-body\"]],[[24,0,\"u--p__t__0\"]],null,[[\"default\"],[[[[1,\"\\n        \"],[10,2],[12],[10,\"strong\"],[12],[1,[28,[35,3],[\"plans.enterprise.modal.submitted.name\"],null]],[13],[1,\" \"],[1,[30,0,[\"formChangeset\",\"name\"]]],[13],[1,\"\\n        \"],[10,2],[12],[10,\"strong\"],[12],[1,[28,[35,3],[\"plans.enterprise.modal.submitted.email\"],null]],[13],[1,\" \"],[1,[30,0,[\"formChangeset\",\"email\"]]],[13],[1,\"\\n      \"]],[]]]]],[1,\"\\n      \"],[8,[30,2,[\"card-footer\"]],null,null,[[\"default\"],[[[[1,\"\\n        \"],[8,[39,4],[[24,0,\"u--float--right qa—requestDemo__close\"]],[[\"@onClick\",\"@text\",\"@variant\"],[[30,1],[28,[37,3],[\"shared_words.close\"],null],\"outline\"]],null],[1,\"\\n      \"]],[]]]]],[1,\"\\n\"]],[]],[[[1,\"      \"],[8,[30,2,[\"card-header\"]],null,null,[[\"default\"],[[[[1,\"\\n        \"],[10,\"h2\"],[14,0,\"o--modalHeader__title\"],[12],[1,[28,[35,3],[\"shared_phrases.request_pricing\"],null]],[13],[1,\"\\n        \"],[10,2],[14,0,\"u--text--light u--m__b__0\"],[12],[1,[28,[35,3],[\"plans.enterprise.modal.description\"],null]],[13],[1,\"\\n      \"]],[]]]]],[1,\"\\n\"],[1,\"      \"],[8,[30,2,[\"card-body\"]],[[24,0,\"u--p__t__0\"]],null,[[\"default\"],[[[[1,\"\\n        \"],[10,\"form\"],[12],[1,\"\\n\"],[1,\"          \"],[10,0],[14,0,\"o--formWrapper u--hide--mf\"],[12],[1,\"\\n            \"],[10,\"label\"],[14,\"for\",\"exampleInput\"],[12],[1,[28,[35,3],[\"plans.enterprise.modal.name\"],null]],[13],[1,\"\\n            \"],[8,[39,5],[[16,0,[28,[37,6],[\"o--form__input qa—requestDemo__ownerName\",[52,[30,0,[\"formChangeset\",\"error\",\"name\"]],\"tMK--asideForm__inputError\"]],null]],[16,\"disabled\",[30,0,[\"handleSubmit\",\"isRunning\"]]],[24,1,\"exampleInput\"],[16,\"placeholder\",[28,[37,3],[\"plans.enterprise.modal.name_placeholder\"],null]]],[[\"@type\",\"@value\"],[\"text\",[30,0,[\"formChangeset\",\"name\"]]]],null],[1,\"\\n\"],[41,[30,0,[\"formChangeset\",\"error\",\"name\"]],[[[1,\"              \"],[10,1],[14,0,\"o--form__helpText u--text--danger qa--requestDemo__nameError\"],[12],[1,\"\\n                \"],[1,[28,[35,3],[\"plans.enterprise.modal.name_error\"],null]],[1,\"\\n              \"],[13],[1,\"\\n\"]],[]],null],[1,\"          \"],[13],[1,\"\\n\"],[1,\"          \"],[10,0],[14,0,\"o--formWrapper u--hide--mf\"],[12],[1,\"\\n            \"],[10,\"label\"],[14,\"for\",\"exampleInput\"],[12],[1,[28,[35,3],[\"plans.enterprise.modal.email\"],null]],[13],[1,\"\\n            \"],[8,[39,5],[[16,0,[28,[37,6],[\"o--form__input qa—requestDemo__ownerEmail\",[52,[30,0,[\"formChangeset\",\"error\",\"email\"]],\"tMK--asideForm__inputError\"]],null]],[16,\"disabled\",[30,0,[\"handleSubmit\",\"isRunning\"]]],[24,1,\"exampleInput\"],[16,\"placeholder\",[28,[37,3],[\"plans.enterprise.modal.email_placeholder\"],null]]],[[\"@type\",\"@value\"],[\"email\",[30,0,[\"formChangeset\",\"email\"]]]],null],[1,\"\\n\"],[41,[30,0,[\"formChangeset\",\"error\",\"email\"]],[[[1,\"              \"],[10,1],[14,0,\"o--form__helpText u--text--danger qa--requestDemo__emailError\"],[12],[1,\"\\n                \"],[1,[30,0,[\"emailErrorMessage\"]]],[1,\"\\n              \"],[13],[1,\"\\n\"]],[]],null],[1,\"          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n      \"]],[]]]]],[1,\"\\n\"],[1,\"      \"],[8,[30,2,[\"card-footer\"]],null,null,[[\"default\"],[[[[1,\"\\n        \"],[8,[39,4],[[24,0,\"qa—requestDemo__close\"]],[[\"@onClick\",\"@text\",\"@variant\"],[[30,1],[28,[37,3],[\"shared_words.close\"],null],\"outline\"]],null],[1,\"\\n        \"],[8,[39,4],[[24,0,\"u--float--right qa—requestDemo__requestBtn\"],[16,\"disabled\",[30,0,[\"isSubmitDisabled\"]]]],[[\"@onClick\",\"@text\",\"@variant\"],[[28,[37,7],[[30,0,[\"handleSubmit\"]]],null],[28,[37,3],[\"shared_phrases.request_pricing\"],null],\"primary\"]],null],[1,\"\\n      \"]],[]]]]],[1,\"\\n\"]],[]]],[1,\"  \"]],[]]]]],[1,\"\\n\"]],[2]]]]]],[\"@closeModal\",\"modal\"],false,[\"shared/modal\",\"not\",\"if\",\"t\",\"shared/ui/button\",\"input\",\"concat-classes\",\"perform\"]]",
    "moduleName": "shared/components/shared/enterprise-modal.hbs",
    "isStrictMode": false
  });

  class Form {
    constructor(_ref) {
      let {
        name,
        email
      } = _ref;

      _defineProperty(this, "name", void 0);

      _defineProperty(this, "email", void 0);

      this.name = name;

      if (email && !(0, _isFreeEmail.isFreeEmail)(email)) {
        this.email = email;
      }
    }

  }

  const validateBusinessEmail = () => {
    return (_key, newEmail) => {
      if ((0, _isFreeEmail.isFreeEmail)(newEmail)) {
        return `Domain not supported`;
      }

      return true;
    };
  };

  const formValidator = {
    name: [(0, _validators.validatePresence)(true)],
    email: [(0, _validators.validateFormat)({
      type: 'email'
    }), validateBusinessEmail(), (0, _validators.validatePresence)(true)]
  };
  let EnterpriseModalComponent = (_class = class EnterpriseModalComponent extends _component2.default {
    constructor(owner, args) {
      super(owner, args);

      _initializerDefineProperty(this, "auth", _descriptor, this);

      _initializerDefineProperty(this, "alerts", _descriptor2, this);

      _initializerDefineProperty(this, "intl", _descriptor3, this);

      _initializerDefineProperty(this, "segment", _descriptor4, this);

      _initializerDefineProperty(this, "hasSuccessfullySubmitted", _descriptor5, this);

      _defineProperty(this, "formChangeset", void 0);

      _defineProperty(this, "handleSubmit", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          this.formChangeset.validate();

          if (this.formChangeset.isValid) {
            try {
              const res = yield (0, _fetch.fetch)('/api/v2/subscription_plans/inquire.json', {
                method: 'POST',
                headers: {
                  'Content-type': 'application/json'
                },
                body: {
                  email: this.formChangeset.email,
                  name: this.formChangeset.name
                }
              }, {
                intl: null,
                numRetries: 0,
                retryStrategy: _retry.STRATEGY.DEFAULT,
                raw: true
              });

              if (res.ok) {
                this.alerts.success(this.intl.t('plans.enterprise.modal.alerts.success.description'), {
                  title: this.intl.t('plans.enterprise.modal.alerts.success.title')
                });
                this.segment.track('requested-demo-enterprise-contact-button');
                this.hasSuccessfullySubmitted = true;
              }
            } catch {
              this.alerts.warning(this.intl.t('alerts.errors.generic'));
            }
          }
        }
      }), null, "handleSubmit", null));

      const {
        name
      } = this.auth.currentUserModel;
      const {
        email
      } = this.auth.currentUserModel;
      this.formChangeset = (0, _emberChangeset.Changeset)(new Form({
        name,
        email
      }), (0, _emberChangesetValidations.default)(formValidator), formValidator);
    }

    get isSubmitDisabled() {
      return !this.formChangeset.email || !this.formChangeset.name || this.formChangeset.errors.length > 0 || this.handleSubmit.isRunning;
    }

    get emailErrorMessage() {
      if (!this.formChangeset.error.email.validation) {
        return undefined;
      }

      const email = this.formChangeset.email;
      const domainFromEmail = email.match(/@(.+)/)?.[1];
      const defaultError = this.intl.t('plans.enterprise.modal.email_error');

      if ((0, _isFreeEmail.isFreeEmail)(email)) {
        return `${defaultError} ${this.intl.t('plans.enterprise.modal.email_domain_not_supported', {
          domain: domainFromEmail
        })}`;
      }

      return defaultError;
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "alerts", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "hasSuccessfullySubmitted", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  })), _class);
  _exports.default = EnterpriseModalComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, EnterpriseModalComponent);
});